import React from "react";
import Slider from "react-slick";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { TitleAnimation } from '../index'
import { graphql, useStaticQuery } from "gatsby"
import * as styles from "./RecruitVoice.module.scss";
import { LinkButton } from "../index"


const RecruitVoice = () => {
  const data = useStaticQuery(
    graphql`
    query{
      site {
        siteMetadata {
          title
          siteUrl
        }
      }
      allWpRecruitVoice (sort: { fields: [date] , order: DESC}){
        edges {
          node {
            title
            slug
            id
            link
            guid
            date(formatString: "YYYY.MM.DD")
            modified(formatString: "YYYY/MM/DD")
            desiredSlug
            databaseId
            featuredImage {
              node {
                localFile {
                  childImageSharp {
                    fluid {
                      src
                      srcSetWebp
                    }
                    gatsbyImageData
                  }
                }
              }
            }
            RecruitVoiceField {
              department
              fieldGroupName
              joindate
            }
          }
        }
      }
    }`
  )

  const page = data.allWpRecruitVoice.edges
  
  //for Slider
  const settings = {
    dots: true,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: 0,
    responsive:[
      {
        breakpoint: 460,
        settings: {
          slidesToShow: 1,
          centerPadding: "15%",
        }
      },
    ]
  };

  const title1 = [
    { "id": 0, "text": "v" },
    { "id": 1, "text": "o" },
    { "id": 2, "text": "i" },
    { "id": 3, "text": "c" },
    { "id": 4, "text": "e" },
  ];

  return(
    <div className={`${styles.RecruitVoice}`}>
      <TitleAnimation data={title1} className={`titleRubikCenter`} />
      <h2 className={`subH2`}>先輩たちの声</h2>
      <div className={styles.RecruitVoice__content}>
        <p className={styles.RecruitVoice__lead}>
        ふかわ養鶏で働く先輩のホンネを<br/>
        インタビューでお届けします!
        </p>
        <Slider {...settings}>
          {page.map(({ node }) => (
            <div key={node.title} className={`${styles.RecruitVoice__list} slide`}>
              <a href={`/voice/${node.databaseId}/`}>
                <div className={`${styles.RecruitVoice__listImg}`}>
                  <span>
                    <picture>
                      <source srcSet={node.featuredImage.node.localFile.childImageSharp.fluid.srcSetWebp} />
                      <img src={node.featuredImage.node.localFile.childImageSharp.fluid.src} alt={node.title} />
                    </picture>
                  </span>
                  <div className={`${styles.RecruitVoice__listText}`}>
                    <span className={`${styles.RecruitVoice__listTextDep}`}>{node.RecruitVoiceField.department}</span>
                    <span className={`${styles.RecruitVoice__listTextJoin}`}>({node.RecruitVoiceField.joindate})</span>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </Slider>
        <div className={styles.RecruitVoice__btn}>
          <LinkButton link={`/voice/`} target="">
            先輩たちの声一覧
          </LinkButton>
        </div>
      </div>
    </div>
  )
}
export default RecruitVoice